import styled, { keyframes } from "styled-components"
import { latencyComp } from "../../../constants"

// TODO: Extract to file so importable here and in QuizPanel
export const expandX = keyframes`
  from { 
    transform: scale3d(0, 1, 1); 
  }
  to { 
    transform: scale3d(1, 1, 1); 
  }
`
export const slideIn = from => keyframes`
  from {
    transform: translate3d(${(from === "left" ? 1 : -1) * 200}%, 0, 0);
  }
  to {
    transform: translate3d(0, 0, 0);
  }
`
export const Bar = styled.div`
  /* Bars are outside the normal document flow */
  position: absolute;

  height: 100%;
  width: 100%;

  border-radius: 2rem;

  background-color: ${props => props.fillColor};
  :hover {
    cursor: ${props => props.isSelectable ? "pointer" : "normal"};
    // Hover color is selected color, but filtered to look more washed out/faint
    background-color: ${props => props.isSelectable ? props.selectedColor : props.fillColor};
    filter: ${props => props.isSelectable ? "brightness(1.3) contrast(0.9)" : "none"};
  }
  transition: background-color 150ms;
`

export const PercentCorrectBar = styled(Bar)`
  /* Anchor to side opposite the one the bar is facing */
  ${props => `${{left: "right", right: "left"}[props.orientation]}`}: 0;

  /* Extend proportionally to percentFull */
  ${props => `${props.orientation}: min(84%, ${100 - props.percentFull}%);`}
  width: auto;

  animation: ${expandX} 1s .2s both;
  transform-origin: ${props => ({left: "right", right: "left"}[props.orientation])};
`
export const Container = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
`

export const TextContent = styled.div`
  font-weight: 700;
  color: ${props => props.fontColor};

  display: flex;
  flex-direction: ${props => ({left: "row-reverse", right: "row"}[props.orientation])};
  column-gap: 5%;
  align-items: center;

  /* Small amount of padding near Bar's tip */
  ${props => `margin-${props.orientation}: 5%;`}
  /* Large amount of padding near Bar's base, always if not mobile, only if revealed if mobile */
  ${props => `margin-${{left: "right", right: "left"}[props.orientation]}: ${!props.isMobile || props.isRevealed ? "auto": "5%"};`}
  width: ${props => props.isMobile ? 90 : 80}%;

  height: 100%;

  position: relative;

  /* Show in front of other elements... */
  z-index: 2;
  /* ...but don't block pointer events for those behind */
  pointer-events: none; 
`
export const Text = styled.span`
  display: flex;
  align-items: center;
  overflow-wrap: anywhere;
`
export const AnswerText = styled(Text)`
  width: max-content;
  /* TODO: Add more font-sizes for different lengths */
  font-size: ${props => props.answerLength > 30 && props.isRevealed ? 86 : 100}%;
  font-weight: 600;
  max-width: ${props => props.isRevealed ? 87 : 100}%;
  
  /* 
    Epic centering technique for transitioning position of dynamic size content 
    1. Move along by 50% of parent width (using left/right %)
    2. Move back by 50% of own width (using translate %)
  */
  ${props => `${props.orientation}: ${props.isRevealed ? 0 : 50}%;`}
  transform: translate3d(${props => props.isRevealed ? 0 : 50 * (props.orientation === "left" ? -1 : 1)}%, 0, 0);

  position: absolute;
  height: 90%;

  transition: transform 0.3s, left 0.3s, right 0.3s;
`
export const NumberAnsweredText = styled(Text)`
  width: 10%;
  font-size: 110%;
  justify-content: ${props => ({left: "flex-start", right: "flex-end"}[props.orientation])};

  animation: ${props => props.isMobile ? "none" : slideIn(props.orientation)} 0.6s 0.4s both;
  transform-style: preserve-3d;
  animation-delay: ${latencyComp}s;
`